import React from "react";
import { Dropdown } from "antd";
import ConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";
import PropTypes from "prop-types";

const TrebbleDropdown = ({ useEditorTheme, ...restProps }) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <ConfigProvider theme={themeConfig}>
      <Dropdown {...restProps} />
    </ConfigProvider>
  );
};

TrebbleDropdown.propTypes = {
  useEditorTheme: PropTypes.bool
};

export default TrebbleDropdown; 